<div class="container px-0 pt-5">
    <div class="mt-4 d-flex justify-content-between align-items-start">
        <img routerLink="/instructions" class="c-pointer" src="assets/icons/back.svg" alt="">
        <span class="text-36-600-119 text-c4 ms-5 ps-5">{{'Join Your Team!' | translate}}</span>
        <button [ngClass]="{'p-e-none': !canEditQuizConfig}" (click)="editQuizSettings()" class="edit-btn d-flex align-items-center gap-2 text-18-500-150 text-c2"> 
            <img src="assets/icons/edit.svg" alt="edit_icon">
            {{'Edit quiz' | translate}}
        </button>
    </div>
    <div class="text-center text-20-500-135 text-c2">{{'Scan this QR Code and enter your team’s code' | translate}}</div>
    <!-- QR code and teams -->
    <div *ngIf="groupData" class="mt-5 d-flex gap-5 w-100">
        <div class="w-fit">
            <div class="qr-container">
                <div style="width: 24rem;">
                    <ngx-qrcode 
                        [elementType]="'url'" 
                        [value]="groupData.qr_code"
                        cssClass="qr-img-container"
                        [margin]="2"
                        [colorLight]="'#FEF8F8'"
                        errorCorrectionLevel="M">
                    </ngx-qrcode>
                    <div *ngIf="groupData?.qr_code" 
                    (click)="CopyQrLink(groupData.qr_code)"
                    class="c-pointer my-3 qr text-center text-20-500-135">
                    {{'Copy link' | translate}}</div>
                    <p class="text-center mt-4 text-20-400-140 text-c2">{{'Scan this QR Code and enter your team’s code' | translate}}</p>
                </div>
                <button [ngClass]="{'p-e-none': !canStartQuiz}" (click)="startQuiz()" class="w-100 start-qz-btn text-16-600-150">{{'Start quiz' | translate}}</button>
                <button [ngClass]="{'p-e-none': !canEditQuizConfig}" (click)="clearQuizConfig()" class="w-100 mt-3 start-qz-btn text-16-600-150">{{'End quiz' | translate}}</button>
            </div>
        </div>
        <div class="col-9 mb-5">
            <div class="grid-teams">
                <div *ngFor="let team of groupData.teamgroup" class="team">
                    <span class="text-20-600-128 text-c7">{{team.name}}</span>
                    <span class="text-24-600-121 text-c4">
                        <img *ngIf="team.is_active" class="pe-3" src="assets/icons/active.svg" alt="">
                        {{team.team_code}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
